module.exports = __webpack_public_path__ + "static/programming-pearls-61b361750832802f0e9eda7075fa0609.jpg";